var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_694_1533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8596 0.508301C3.08951 0.508301 0.00390625 3.59383 0.00390625 7.364V28.6384C0.00390625 32.4085 3.08944 35.493 6.8596 35.493H28.134C31.9042 35.493 34.9886 32.4086 34.9886 28.6384V7.364C34.9886 3.5939 31.9042 0.508301 28.134 0.508301H6.8596ZM8.58391 6.28148C10.3916 6.28148 11.505 7.46819 11.5394 9.02811C11.5394 10.5536 10.3915 11.7736 8.54895 11.7736H8.51503C6.74176 11.7736 5.59561 10.5537 5.59561 9.02811C5.59561 7.46823 6.77648 6.28148 8.58391 6.28148ZM24.1617 13.5723C27.6382 13.5723 30.2444 15.8446 30.2444 20.7276V29.8433H24.961V21.3388C24.961 19.2017 24.1964 17.7436 22.2843 17.7436C20.8247 17.7436 19.9547 18.7264 19.5727 19.6757C19.4331 20.0153 19.3988 20.4897 19.3988 20.9648V29.8433H14.1155C14.1155 29.8433 14.1848 15.4369 14.1155 13.9452H19.3999V16.1965C20.102 15.1132 21.3579 13.5723 24.1617 13.5723ZM5.90725 13.9463H11.1906V29.8434H5.90725V13.9463Z",
    fill: "#0072B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_694_1533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0 0.499512)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1655277664a7cbad77f25dc95bcbae5b.svg";
export { ForwardRef as ReactComponent };